import { Logger } from '@precert/logger';
import isString from 'lodash/isString';
import React, { useContext, useState, useEffect } from 'react';

const log = Logger('app:config');

export type ConfigType = {
  cloudflareTurnstileKey: string;
  features: string[];
  api: string;
  infusionProcedureCodes?: string[];
  maxFileSizeMegaBytes: number;
  sessionPollSecs: number;
  idleWarningSecs: number;
  env: string;
  maxSubmitAttempts: number;
};

const ConfigContext = React.createContext<ConfigType | Record<string, never>>(
  {}
);

export function useConfig() {
  const config = useContext(ConfigContext);
  if (!config) {
    throw new Error('useConfig has to be used within ConfigProvider');
  }
  return config;
}

export function ConfigProvider({
  config,
  children,
}: {
  config: string;
  children: React.ReactNode;
}) {
  const [state, setState] = useState({ initialized: false, config: {} });

  // TODO CCRA-37242
  useEffect(() => {
    if (isString(config)) {
      log.info('Loading remote configuration from url %s', config);
      fetch(config)
        .then((r) => {
          if (!r.ok)
            throw new Error(
              'ConfigProvider: Error loading remote configuration ' + r.status
            );
          return r;
        })
        .then((r) => r.json())
        .then((data) => {
          setState({ initialized: true, config: data });
        });
    } else {
      log.info('Local configuration: %o', config);
      // TODO CCRA-37242
      setState({ initialized: true, config });
    }
  }, [config]);
  if (!state.initialized) return null;
  return (
    <ConfigContext.Provider value={state.config}>
      {children}
    </ConfigContext.Provider>
  );
}
